import Invoice from 'model/Invoice'

import globalFnFactory from 'components/globalFn/globalFnFactory'

const globalFn = globalFnFactory()
class modalInvoiceInfo {
    constructor($scope, $uibModalInstance, httpRequest, invoice) {
        httpRequest.get_dictByTypeArr(['ovat_tax_rate']).then((res) => {
            $scope.ivatTaxRate = res.data.value.ovat_tax_rate
        })
        httpRequest.get_getInvoice(invoice).then((res) => {
            $scope.invoice = new Invoice(res.data.value)
            $scope.invoice.invType = $scope.invoice.invoiceType
            $scope.invoice.chineseAmtTotal = globalFn.digitUppercase($scope.invoice.adValoremTotal)
            if (res.data.value.invoiceType == '41' || res.data.value.invoiceType == '12') $scope.codeVersions = $scope.invoice.details[0].revenueVersion
        })
        $scope.cancel = () => {
            $uibModalInstance.close()
        }
    }
}
modalInvoiceInfo.$inject = ['$scope', '$uibModalInstance', 'httpRequest', 'invoice']
export default modalInvoiceInfo



// WEBPACK FOOTER //
// ./src/app/input/reimburseManage/reimbursement/modalInvoiceInfo.js